import { render, staticRenderFns } from "./BooksListItem.vue?vue&type=template&id=1331057f&"
import script from "./BooksListItem.vue?vue&type=script&lang=js&"
export * from "./BooksListItem.vue?vue&type=script&lang=js&"
import style0 from "./BooksListItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports